
import React from 'react';
import { Input } from '@/components/ui/input';
import { MessageSquare } from 'lucide-react';

interface ChatSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const ChatSearch = ({ searchTerm, setSearchTerm }: ChatSearchProps) => {
  return (
    <div className="relative w-full md:w-96">
      <Input
        placeholder="Search chat titles and content..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10"
      />
      <MessageSquare className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
    </div>
  );
};

export default ChatSearch;
